import { useCallback } from 'react';

import { useIsomorphicLayoutEffect } from '@r1-frontend/shared/hooks/useIsomorphicLayoutEffect';

// @todo this effect must be used in the true Popup Component (we should implement absolutely effective Popup Component in @r1-frontend/ui-react)
export const useScrollLock = () => {
    const lockScroll = useCallback(() => {
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = 'var(--scrollbar-compensation)';
        document.body.dataset.scrollLock = 'true';
    }, []);

    const unlockScroll = useCallback(() => {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        delete document.body.dataset.scrollLock;
    }, []);

    useIsomorphicLayoutEffect(() => {
        // calculation the width of scrollbar
        const scrollBarCompensation = window.innerWidth - document.body.offsetWidth;
        document.body.style.setProperty('--scrollbar-compensation', `${scrollBarCompensation}px`);
    }, []);

    return {
        lockScroll,
        unlockScroll,
    };
};

export default useScrollLock;
